import React from 'react';
import HomePage from '../components/Views/HomePage';
import Layout from '../components/Layout/Layout';
import { getSeoData } from '../utils/helpers';
import initApollo from '../utils/init-Apollo';
import { getInitialItems, getCombinedHomePageData } from '../api/queries';
import { REVALIDATE_SECONDS, ITEMS_LIMIT } from '../utils/constants/homePage';
import { extractApolloState } from '../utils/helpers/extractApolloState';
import { loadHomePageMockData } from '../utils/helpers/getHomePageMockData';
import { withBugsnagGetServerSideProps } from '../utils/withBugsnag';

const App = props => <HomePage {...props} />;

const isE2E = process.env.NEXT_PUBLIC_E2E === '1';

const STALE_WHILE_REVALIDATE_SECONDS = 86400;

export const getServerSideProps = withBugsnagGetServerSideProps(
  async ({ locale, res }) => {
    res.setHeader(
      'Cache-Control',
      `public, s-maxage=${REVALIDATE_SECONDS}, stale-while-revalidate=${STALE_WHILE_REVALIDATE_SECONDS}`
    );

    const apolloClient = initApollo({}, { lang: locale });

    if (isE2E && process.env.NODE_ENV !== 'production') {
      try {
        await loadHomePageMockData(apolloClient);

        return extractApolloState(apolloClient, {
          props: {
            seoData: null,
            currentLang: locale
          }
        });
      } catch (error) {
        console.error('Error loading mock data:', error);
      }
    }

    try {
      const [seoData] = await Promise.all([
        getSeoData(apolloClient),
        apolloClient.query({ query: getCombinedHomePageData }),
        apolloClient.query({
          query: getInitialItems,
          variables: {
            limit: ITEMS_LIMIT,
            offset: 0
          }
        })
      ]);

      return extractApolloState(apolloClient, {
        props: {
          seoData,
          currentLang: locale
        }
      });
    } catch (error) {
      res.setHeader('Cache-Control', 'no-store');
      throw error;
    }
  },
  'index',
  ({ locale }) => ({
    seoData: null,
    apolloState: {},
    currentLang: locale
  })
);

App.getLayout = (page, pageProps) => (
  <Layout pageProps={pageProps} isHomePage isBanner isBackgroundBanner>
    {page}
  </Layout>
);

export default App;
